var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33492 12.7838L15.8529 2.12203C16.2939 1.62523 15.9306 0.847715 15.2667 0.867098L0.981886 1.32567C0.439343 1.33818 0.0975926 1.90498 0.323822 2.38922L1.7859 5.53656C1.94522 5.87757 2.33458 6.05295 2.69471 5.93455L12.934 2.7213L3.89596 8.5058C3.57725 8.71286 3.46191 9.12403 3.62123 9.46504L5.09695 12.606C5.32318 13.0902 5.97719 13.1918 6.33492 12.7838Z",
    fill: "#091A32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendicon);
export default __webpack_public_path__ + "static/media/sendicon.96ad5c6ce7d2f6880b96785c383420f5.svg";
export { ForwardRef as ReactComponent };